import { custom } from "devextreme/ui/dialog";
import { centerTextMessageBox } from "../../lib/utils";
import { CSSClasses } from "../../lib/utilsCSS";

/**
 * @deprecated Use messageBox2 instead
 */
export async function messageBox(title: string, htmlMessage: string, content: string = "", btnTrue: string, btnFalse: string = "", width: number = 0): Promise<boolean> {
  let mssg = width > 0 ? `<div style='width: ${width}px'><b>${htmlMessage}</b></div>` : `<b>${htmlMessage}</b>`;
  if (content !== "") mssg = `${mssg}<br>${content}`;

  let btns = [
    {
      text: btnTrue,
      onClick: () => {
        return { result: true };
      },
    },
  ];

  if (btnFalse !== "")
    btns.push({
      text: btnFalse,
      onClick: () => {
        return { result: false };
      },
    });

  let myDialog = custom({
    title: title,
    messageHtml: `<div id='pr_popup__messageBox'>${mssg}</div>`,
    buttons: btns,
    dragEnabled: true,
    showTitle: title !== "",
  });

  return myDialog.show();
}

export async function messageBox2({
  title = "",
  header = "",
  content = "",
  accept = "",
  cancel = "",
  width = 0,
  useIcon = true,
  centerText = true,
  detailsConfig = { text: "", title: "" },
}: {
  title: string;
  header: string;
  content: string;
  accept: string;
  cancel: string;
  width: number;
  useIcon: boolean;
  centerText: boolean;
  detailsConfig: any;
}): Promise<boolean> {
  let body = "";

  if (header) {
    body = width > 0 ? `<div style='width: ${width}px'>${header}</div>` : header;
  }

  if (content) body = `${body}<br>${content}`;
  if (centerText) body = centerTextMessageBox(body);

  if (detailsConfig.text) {
    const style = "border: 1px solid #e9e9e9; border-radius:0.25rem 0.25rem 0 0; padding:0.5rem; margin-bottom: 0.5rem; height:10rem; overflow-y:auto";
    const styleTitle = "font-weight: 600; color:#ababab";
    body = body + `<br><div style='width: ${width}px;${style}'><span style='${styleTitle}'>${detailsConfig.title ?? ""}</span><br><br>${detailsConfig.text}</div>`;
  }

  const buttons = [
    {
      text: accept,
      icon: useIcon ? CSSClasses.ICON_ACCEPT : "",
      onClick: () => {
        return { result: true };
      },
    },
  ];

  if (cancel)
    buttons.push({
      text: cancel,
      icon: useIcon ? CSSClasses.ICON_CANCEL : "",
      onClick: () => {
        return { result: false };
      },
    });

  body = `<div id='pr_popup__messageBox'>${body}</div>`;

  const dialog = custom({
    title: title,
    messageHtml: body,
    buttons: buttons,
    dragEnabled: true,
    showTitle: title !== "",
  });

  return dialog.show();
}
